export default __webpack_public_path__ + "static/logoPattern-d9064557e14d76fe99bb98f2685a3f19.png";